/* eslint-disable */
import { axios } from 'cm'
import ReportEntry from '../../../../frontend-lib/component/reportPopup/index.js'

handleWxDownApp()

const opts = {
  objectName: 'fm',
  objectId: () => getFmId(),
  $http: axios,
  handleResponse: res => res.data
}
new ReportEntry(opts).start()

/**
 * 获取FM的id值。
 * 首先从URL中获取，例如：https://m-box4.xinli001.com/fm/99388713
 * 但是https://m-box4.xinli001.com/fm中也有FM播放，这个则要从DOM中获取
 */
function getFmId() {
  const pathname = window.location.pathname
  const regex = /fm\/(\d+)/
  if (regex.test(pathname)) {
    return pathname.match(regex)[1]
  }

  const activeItem = document.querySelector('#img-div li.active')
  if (activeItem) {
    return activeItem.getAttribute('data-id')
  }

  return null
}

// 微信端点击举报需引导到FM App下载页
function handleWxDownApp() {
  let isWechat = /MicroMessenger\/([\d/.]+)/i.test(navigator.userAgent)
  if (isWechat) {
    const $reportBtn = document.querySelector('#yxl-article-report-btn')
    const $tpl = `
      <span
        id="yxl-open-fm-app-for-report-btn"
        style="position: absolute; width: 100%; height: 100%; left: 0; top: 0"
      ></span>
    `
    $reportBtn.insertAdjacentHTML('beforeend', $tpl)

    setTimeout(() => {
      const $btn = document.querySelector('#yxl-open-fm-app-for-report-btn')
      $btn &&
        $btn.addEventListener('click', () => {
          window.location.href = 'https://d.xinli001.cc/fm/dl'
        })
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/pages/fm/hotSowingFM/module/reportEntry.js